import React from 'react'
import { AuthRoles } from '../../Component/Auth/AuthRoles.js';

const ContentsRoute = [
    {
        path: '/contents',
        component: React.lazy(() => import('./Contents.js')),
        auth: AuthRoles.editor,
    }
]

export default ContentsRoute;